/**
 * React Query hooks for analytics.
 */

import { useQuery } from '@tanstack/react-query';
import { analyticsApi } from '@/api/client';

export function useCascade(placementId: string, window = '24h') {
  return useQuery({
    queryKey: ['cascade', placementId, window],
    queryFn: () => analyticsApi.getCascade(placementId, window),
    staleTime: 30 * 1000, // 30 seconds
  });
}

export function useTopSparks(params?: { from?: string; to?: string; limit?: number }) {
  return useQuery({
    queryKey: ['top-sparks', params],
    queryFn: () => analyticsApi.getTopSparks(params),
    staleTime: 30 * 1000,
  });
}

export function useTimeSeries(
  placementId: string,
  params?: { from?: string; to?: string; interval?: '1h' | '1d' | '1w' }
) {
  return useQuery({
    queryKey: ['timeseries', placementId, params],
    queryFn: () => analyticsApi.getTimeSeries(placementId, params),
    staleTime: 30 * 1000, // 30 seconds
  });
}

export function useUsage() {
  return useQuery({
    queryKey: ['usage'],
    queryFn: () => analyticsApi.getUsage(),
    staleTime: 30 * 1000,
  });
}

